import { useEvent } from "shared/lib/useEvent"
import { useRedux } from "shared/lib/useRedux"

import { BuildingReferenceState } from "pages/building-reference-page/model/store/buildingReferenceSlice"
import { useBuildingReferenceActions } from "pages/building-reference-page/model/store/useBuildingReferenceActions"

const defaultState: BuildingReferenceState = {
  activeProductFilters: []
}

export function useBuildingReferenceState(id: string | null | undefined) {
  const { activeProductFilters } = useRedux(({ buildingReference }) =>
    id ? buildingReference[id] || defaultState : defaultState
  )
  const { setActiveProductFilters } = useBuildingReferenceActions()

  const setActiveProductFiltersHandler = useEvent(
    (nextActiveProductFilters: string[]) => {
      if (id) {
        setActiveProductFilters({
          activeProductFilters: nextActiveProductFilters,
          buildingReferenceID: id
        })
      }
    }
  )

  return {
    activeProductFilters,
    setActiveProductFilters: setActiveProductFiltersHandler
  }
}
